import { Component, Vue } from 'vue-property-decorator';
import LanguageSwitch from '@/components/language-switch/LanguageSwitch';
import { identifyApplication, identifyHostname } from '@/support/Client';
import axios, { AxiosError, AxiosResponse } from 'axios';
import i18n from '@/i18n';
import ErrorHandler from '@/support/ErrorHandler';
import { validationRules } from '@/support/ValidationRules';
import LoaderCard from '@/components/loader-card/LoaderCard';
import RenderFlow from '@/support/RenderFlow';

@Component<ForgotPassword>({
  components: {
    LanguageSwitch,
    LoaderCard
  },
})
export default class ForgotPassword extends Vue {
  public apiServer: string = identifyHostname() || '';
  private valid: boolean = true;
  private email: string = '';
  protected rules: object = validationRules(this.getTranslation);

  private RenderFlow = new RenderFlow(['isLoading','isSubmitted']);

  public getTranslation(key: string) {
    return this.$t(key);
  }



  public submit() {
    if (!this.email) {
      return;
    }

    this.RenderFlow.set('isLoading', true)

    //this.isLoading = true;

    const payload = {
      email: this.email
    }

    let headers = {};

    if (window.location.hostname !== 'localhost') {
      (headers as any)['X-Application'] = identifyApplication();
      (headers as any)['Accept-Language'] = i18n.locale;
    }

    const client = axios.create({
      baseURL: this.apiServer,
      headers,
    });

    client
      .post('/v1/password/forgot', payload)
      .then((response: AxiosResponse) => {
        this.RenderFlow.set('isSubmitted', true);
        this.RenderFlow.set('isLoading', false)
        // this.isSubmitted = true;
        // this.isLoading = false;
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
        this.RenderFlow.set('isLoading', false);
        // this.isLoading = false;
      });
  }
}
